<div class="flyout-contact-information-component">
  @if (personalData || customProperties) {
    <div class="flyout-data-group">
      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
        <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
          <img class="header-icon" src="/assets/img/icons_fl/user-analytics.svg" width="32px" height="32px" />
          <span>{{ "flyout.contact-info.general-details" | translate }}</span>
        </mat-expansion-panel-header>
        @if (personalData?.email) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/email.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.email" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.email"></span>
              <!--<span *ngIf="!personDetails?.email" class="no-value">{{('flyout.contact-info.add' | translate) + ' ' + ('flyout.contact-info.email' | translate)}}</span>-->
            </div>
          </div>
        }
        @if (personalData?.name) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/user-filled.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.name" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.name"></span>
              <!--<span *ngIf="!personDetails?.name" class="no-value">{{'flyout.contact-info.add' | translate}} {{'flyout.contact-info.name' | translate}}</span>-->
            </div>
          </div>
        }
        @if (personalData?.firstName) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/user-filled.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.firstName" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.firstName"></span>
            </div>
          </div>
        }
        @if (personalData?.lastName) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/user-filled.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.lastName" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.lastName"></span>
            </div>
          </div>
        }
        @if (personalData?.phone) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/mobile.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.phone" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.phone"></span>
            </div>
          </div>
        }
        @if (personalData?.title) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/user-filled.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.title" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.title"></span>
            </div>
          </div>
        }
        @if (personalData?.username) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/user-filled.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.username" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.username"></span>
            </div>
          </div>
        }
        @if (personalData?.organization) {
          <div class="expansion-panel-row no-border">
            <div class="label">
              <img class="label-icon" src="/assets/img/icons_fl/user-filled.svg" width="24px" height="24px" />
              <span>{{ "flyout.contact-info.organization" | translate }}</span>
            </div>
            <div class="value">
              <span class="existing" [innerHTML]="personalData?.organization"></span>
            </div>
          </div>
        }
        <!-- Custom properties -->
        @if (customProperties?.length) {
          @for (property of customProperties; track property) {
            <div class="expansion-panel-row no-border">
              <div class="label">
                <img class="label-icon" src="/assets/img/icons_fl/settings.svg" width="24px" height="24px" />
                <span>{{ (property.displayName | translate) || property.key }}</span>
              </div>
              <div class="value">
                <span class="existing" [innerHTML]="property.value"></span>
              </div>
            </div>
          }
        }
      </mat-expansion-panel>
    </div>
  }
</div>
